var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.55556V10.8889C14 11.3604 13.8276 11.8126 13.5207 12.146C13.2138 12.4794 12.7976 12.6667 12.3636 12.6667H3.63636C3.20237 12.6667 2.78616 12.4794 2.47928 12.146C2.1724 11.8126 2 11.3604 2 10.8889V3.77778C2 3.30628 2.1724 2.8541 2.47928 2.5207C2.78616 2.1873 3.20237 2 3.63636 2H6.32545C6.5954 1.99989 6.86119 2.07234 7.09911 2.21089C7.33704 2.34944 7.53972 2.54979 7.68909 2.79407L8.13091 3.51111C8.18032 3.59263 8.2475 3.65962 8.32648 3.70615C8.40546 3.75267 8.4938 3.77727 8.58364 3.77778H12.3636C12.7976 3.77778 13.2138 3.96508 13.5207 4.29848C13.8276 4.63188 14 5.08406 14 5.55556Z",
    fill: "url(#paint0_linear_14_12320)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_14_12320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 6.22206V11.5554C14.6667 12.0269 14.4943 12.4791 14.1875 12.8125C13.8806 13.1459 13.4644 13.3332 13.0304 13.3332H4.30311C3.86912 13.3332 3.45291 13.1459 3.14603 12.8125C2.83915 12.4791 2.66675 12.0269 2.66675 11.5554V4.44428C2.66675 3.97279 2.83915 3.5206 3.14603 3.1872C3.45291 2.85381 3.86912 2.6665 4.30311 2.6665H6.9922C7.26215 2.66639 7.52793 2.73884 7.76586 2.87739C8.00379 3.01594 8.20647 3.21629 8.35584 3.46058L8.79766 4.17762C8.84707 4.25913 8.91425 4.32613 8.99323 4.37265C9.07221 4.41917 9.16054 4.44378 9.25038 4.44428H13.0304C13.4644 4.44428 13.8806 4.63158 14.1875 4.96498C14.4943 5.29838 14.6667 5.75056 14.6667 6.22206Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14_12320",
    x: 0.766748,
    y: 0.766504,
    width: 15.8,
    height: 14.4665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14_12320"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14_12320",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_12320",
    x1: 8,
    y1: 2,
    x2: 8,
    y2: 12.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BF35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAD730"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.b8538a711cb0901ee2818097c813e5d5.svg";
export { ForwardRef as ReactComponent };